
<template>
    <div class="container">
        <div class="personal_account">
            <h1 class="personal_account_title">
                Добрый день, <span v-html="user.name"></span>
            </h1>
            <div class="personal_account_company">
                <div class="personal_account_company_info">
                    <p>
                        Компания: <span v-html="selectedCompany?.name"></span>
                    </p>
                    <p>{{ selectedCompany?.name }} {{ selectedCompany?.inn }} </p>
                </div>
                <div class="personal_account_company_select">
                    <a-select v-model:value="selectedCompanyId" class="personal_account_company_select_item" @change="changeCompany">
                        <a-select-option v-for="item in companies" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="card-container">
                <a-tabs v-model:activeKey="activeKey" type="card">
                    <a-tab-pane key="contracts" tab="Мои договора">
                        <ContractsTab :selectedCompanyId="selectedCompanyId"/>
                    </a-tab-pane>
                    <a-tab-pane key="contract_objects" tab="Договора по объектам">
                       <ContractsObjectsTab :selectedCompanyId="selectedCompanyId"/>
                    </a-tab-pane>
                    <a-tab-pane key="contract_payments" tab="Выплаты">
                        <ContractsPaymentsTab :selectedCompanyId="selectedCompanyId"/>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import { Tabs, Input, DatePicker, Divider, Button, Spin, Table, Select, ConfigProvider, TreeSelect} from 'ant-design-vue'
  import ContractsTab from '@/components/personalAccount/ContractsTab.vue';
  import ContractsObjectsTab from '@/components/personalAccount/ContractsObjectsTab.vue';
  import ContractsPaymentsTab from '@/components/personalAccount/ContractsPaymentsTab.vue';
  import ruRu from 'ant-design-vue/es/locale/ru_RU'
  import {MinusCircleOutlined, SearchOutlined, CalendarOutlined, DownloadOutlined} from '@ant-design/icons-vue'
  import axios from 'axios';
  import { useToast } from 'vue-toastification'
  import store from '@/store'
  import dayjs from 'dayjs';
  import moment from 'moment';
  import VueTheMask from 'vue-the-mask'
  import 'moment/locale/ru';
  import 'dayjs/locale/ru';
  import router from "@/router";
  dayjs.locale('ru');
  moment.locale('ru');
  const toaster = useToast();
const contractObjectColumns =  [
  {
    title: 'Наименование продукта',
    dataIndex: 'product',
    key: 'product',
  },
  {
    title: 'Номер договора',
    dataIndex: 'contract_number',
    key: 'contract_number',
  },
  {
    title: 'Гос.номер ТС',
    dataIndex: 'plate_number',
    key: 'plate_number',
  },
  {
    title: 'VIN-код',
    dataIndex: 'vin',
    key: 'vin',
  },
  {
    title: 'Дата начала договора',
    dataIndex: 'start_date',
    key: 'start_date',
  },
  {
    title: 'Дата окончания договора',
    dataIndex: 'end_date',
    key: 'end_date',
  },
  {
    title: 'Страховая премия',
    dataIndex: 'insurance_premium',
    key: 'insurance_premium',
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
  },
];

  export default {
      components: { 
          AInput: Input, 
          ADatePicker: DatePicker, 
          ADivider: Divider, 
          AButton: Button,
          ASpin: Spin, 
          ATabs: Tabs,
          ATabPane: Tabs.TabPane,
          ATable: Table,
          MinusCircleOutlined,
          SearchOutlined,
          CalendarOutlined,
          DownloadOutlined,
          ASelect: Select,
          ASelectOption: Select.Option,
          AConfigProvider: ConfigProvider,
          ATreeSelect: TreeSelect,
          ContractsTab,
          ContractsObjectsTab,
          ContractsPaymentsTab
      },  
      data() {
          return {
              ruRu,
              user: store.getters['auth/getUser'],
              selectedCompany: null,
              selectedCompanyId: null,
              notifications: [],
              activeKey: 'contract_objects',
              companies: [],
              searchData: {
                search: null,
                type_id: 1,
                contract_type: null,
                start_date: null,
                end_date: null,
              },
              contractObjectColumns,
              contractList: [],
              productTypeList: [],
              contractTypeList: [],
              contractsObjectsList: [],
              isLoadingContractsObjectsList: false,
          }
      }, 
      mounted() { 
        if(localStorage.getItem("auth_token")){
             axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("auth_token")}`
        }
        
        if(this.user && this.user.companies && this.user.companies.length > 0){
            this.companies = this.user.companies
            this.selectedCompany = this.user.companies[0]
            this.selectedCompanyId = this.user.companies[0].id
        }
        this.isLoadingContractList = true
        this.isLoadingContractsObjectsList = true
        // this.getProductList()
        //  this.getQuestionnaireData(this.$route.params.id.split('-').join(''))
        //  this.getAllDicties()
      },
      methods: {
        getContracts(data){
          axios.get(`/V1/my-contracts?company_id=${this.selectedCompanyId}`, {params: data}).then(res => {
              this.contractList = res.data.data.contracts;
              this.isLoadingContractList = false
          }).catch(error => {
              console.log(error);
          })
      },
        getContractsObject(data){
            axios.get(`/V1/my-contracts/objects?company_id=${this.selectedCompanyId}`, {params: data}).then(res => {
                console.log(res.data.data);
                
                this.contractsObjectsList = res.data.data.contracts_with_objects;
                this.isLoadingContractsObjectsList = false
            }).catch(error => {
                console.log(error);
            })
        },
        getProductList(){
            axios.get(`/V1/my-contracts/type-products?company_id=${this.selectedCompanyId}`).then(res => {
                this.productTypeList = res.data.data.types.map(item => {
                    return {
                        label: item.label,
                        value: item.id,
                        children: item.products.map(product => {
                            return {
                                label: product,
                                value: product,
                            }
                        })
                    }
                });
                this.contractTypeList =  res.data.data.types.filter(item => item.id === 1)[0].products.map(item => {
                    return {
                        label: item,
                        value: item
                    }
                })
                if(this.contractTypeList.length === 1){
                    this.searchData.contract_type = this.contractTypeList[0].value
                }
                this.getContracts({...this.searchData, start_date: this.searchData.start_date? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY'): null})
                // this.getContractsObject({...this.searchData, start_date: this.searchData.start_date? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY'): null})
            }).catch(error => {
                console.log(error);
                if(error.status === 401){
                    store.dispatch('auth/logoutTokenUnactive')
                    router.push('/')
                }
                
            })
        },
        onChangeContractNum(e){
            this.searchData.search = e.target.value
        },
        onChangeProductType(e){
            this.searchData.product_type = e
        },
        onChangeContractType(e){
            this.searchData.contract_type = e
        },
        onChangeStartDate(e){
            this.searchData.start_date = e
        },
        onChangeEndDate(e){
            this.searchData.end_date = e
        },
        searchContract(){
            this.getContracts({...this.searchData, start_date: this.searchData.start_date? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY'): null})
        },
        async downloadFile(record){
            try{
                const response = await axios.get(record.file_path, {
                    responseType: 'blob', 
                })
                const blob = new Blob([response.data])
                const downloadUrl = window.URL.createObjectURL(blob)

                const link = document.createElement('a')
                link.href = downloadUrl
                link.download = `${record.number}.pdf`
                document.body.appendChild(link)
                link.click()
                link.remove()

                window.URL.revokeObjectURL(downloadUrl)
            }catch(error){
                console.log(error);
                
            }
        },
        changeCompany(companyId){
            this.selectedCompany = this.companies.find(item => item.id === companyId)
        }
      },
  }
  </script>
  
  <style lang="scss" scoped>
      @mixin fontStyle ($family,$style,$weight, $size, $lheight, $color) {
          font-family: $family;
          font-style: normal;
          font-weight: $weight;
          font-size: $size;
          line-height: $lheight;
          color: $color;
      }
      @mixin mobile {
          @media(min-width: 320px) and (max-width: 425px) {
              @content;
          }
      }
      @mixin tablet {
          @media(min-width: 425px) and (max-width: 767px) {
              @content;
          }
      }
      @mixin tablet-1024 {
          @media(min-width: 767px) and (max-width: 1024px) {
              @content;
          }
      }
      @mixin desktop {
          @media(min-width: 1024px) and (max-width: 1440px) {
              @content;
          }
      }
      @mixin desktop-max {
          @media(min-width: 1620px) and (max-width: 2560px) {
              @content;
          }
      }
      .col_p{
          margin-bottom: 0;
      }
    .personal_account{
        padding: 30px 0;
        &_company{
            display: flex;
            justify-content: space-between;
            align-items: center;
            &_info{
                width: 60%;
                p{
                    font-size: 18px;
                    span{
                        font-weight: 700;
                    }
                }
                
            }
        }
        &_title{
            @include fontStyle(Roboto, normal, 500, 24px, 31px, #373737);
            text-align: center;
        }
        &_desc{
            @include fontStyle(Roboto, normal, 400, 22px, 31px, #909090);
            text-align: center;
            span{
                @include fontStyle(Roboto, normal, 400, 22px, 31px, #373737);
            }
        }
        &_info{
            @include fontStyle(Roboto, normal, 400, 24px, 31px, #373737);
            display: flex;
            justify-content: space-between;
            align-items: center;
            &_left{
                width: 30%;
                @include fontStyle(Roboto, normal, 400, 20px, 31px, #373737);
                &_select{
                    width: 100%;
                    height: 50px;
                }
            }
            &_right{
                button{
                    @include fontStyle(Roboto, normal, 400, 16px, 31px, #373737);
                    padding: 4px 20px;
                    height: 55px;
                    display: flex;
                    align-items: center;
                    img{
                        width: 24px;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
    ::v-deep(.personal_account_company_select_item){
        .ant-select-selector{
            background: #fff;
            border: 1px solid #F5F5F5;
            height: 50px;
            background: #F4F4F8;
            display: flex;
            align-items: center;
            width: 400px;

        }
    }
    ::v-deep(.personal_account_info_left){
        .ant-select-selector{
            height: 50px;
            input{
                height: 50px;
            }
            .ant-select-selection-placeholder{
                height: 50px;
                display: flex;
                align-items: center;
            }
        }
    }
    .product_name_col{
        display: flex;
        gap: 10px;
        align-items: center;
    }
    .product_name_line{
        height: 38px;
        width: 5px;
        background: #007BFF;
        border-radius: 3px;
    }
    .download_btn, .open_btn{
        background-color: #fff;
        padding: 4px 8px;
        border: 2px solid #F5F5F5;
        border-radius: 4px;
        cursor: pointer;
    }
    .download_btn{
        margin-right: 15px;
        span{
            color: #007BFF;
            font-size: 18px;
        }
    }
    .search_form{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        &_input{
            width: 100%;
        }
        &_date{
            display: flex;
            width: 38%;
            justify-content: space-between;
            height: 50px;
            align-items: center;
            gap: 15px;
            p{
                @include fontStyle(Roboto, normal, 400, 20px, 31px, #373737);
            }
            &_item{
                background: #fff;
                border-radius: 8px;
                width: 100%;
                span{
                    background: #fff;
                    color: #007BFF;
                    border: none;
                    font-size: 18px;
                }
                .ant-picker{
                    background: #fff;
                    border: none;
                    height: 50px;
                }
                .ant-picker-focused{
                    box-shadow: none;
                }
            }
        }
        &_select{
            width: 19%;
            height: 50px;
        }
        button{
            @include fontStyle(Roboto, normal, 400, 18px, 31px, #373737);
            height: 50px !important;
            border: none;
            background-color: #007BFF;
            color: #fff;
            width: 19%;
        }
    }
    ::v-deep(.search_form){
        .search_form_input_item{
            height: 50px;
            border: none;
            .anticon-search{
                font-size: 18px;
            }
        }
        .search_form_input_item:focus{
            box-shadow: none;
        }
        .search_form_select .ant-select-selector{
            border: none;
            height: 50px;
            input{
                padding: 24px 0;
                display: flex;
                align-items: center;
            }
            .ant-select-selection-placeholder{
                display: flex;
                align-items: center;
            }
            .ant-select-selection-item{
                display: flex;
                align-items: center;
            }
        }
    }
    ::v-deep(.ant-tabs){
        .ant-tabs-nav-list{
            background: #F4F4F8 !important;
            border-radius: 8px;
            width: 100%;
            justify-content: space-between;
            padding: 15px 25px;
            .ant-tabs-tab-active{
                background: white !important;
            }
            .ant-tabs-tab{
                display: flex;
                justify-content: center;
                width: 30%;
                border: none;
                background: none;
                div{
                    font-size: 22px;
                    color: #373737;
                    border-radius: 8px;
                    padding: 7px 0;
                }
            }
        }
        .ant-tabs-content-holder{
            margin-top: 20px;
            .ant-tabs-tabpane{
                background: #F4F4F8 !important;
                border-radius: 8px;
            }
        }
    }
    .card-container p {
        margin: 0;
    }
    .ant-tabs-nav-wrap{
       
    }
    .card-container > .ant-tabs-card .ant-tabs-content {
        height: 120px;
        margin-top: -16px;
    }
    .card-container > .ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane {
        padding: 16px;
        background: #fff;
    }
    .card-container > .ant-tabs-card > .ant-tabs-nav::before {
        display: none;
    }
    .card-container > .ant-tabs-card .ant-tabs-tab,
    [data-theme='compact'] .card-container > .ant-tabs-card .ant-tabs-tab {
        background: transparent;
        border-color: transparent;
    }
    .card-container > .ant-tabs-card .ant-tabs-tab-active,
    [data-theme='compact'] .card-container > .ant-tabs-card .ant-tabs-tab-active {
        background: #fff;
        border-color: #fff;
    }
    #components-tabs-demo-card-top .code-box-demo {
        padding: 24px;
        overflow: hidden;
        background: #f5f5f5;
    }
  </style>
  
  